"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./DuTrendUtils";

export default function DuThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`du-ods-detail-item kbv-hbet-odt-card ${width}`}>
      <div className="du-odstb-title kbv-hbet-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="du-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="du-title-odds">{item.label}</div>
            <div
              className={`du-odds kbv-hbet-odt-odds ods-100 du-ods-white ${trendClass(
                item.trend,
              )}`}
            >
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

